import React from 'react';

import './error-box.scss';

interface ErrorBoxProps {
    message: string;
}

export const ErrorBox: React.FC<ErrorBoxProps> = ({ message }): React.ReactElement => {
    return (
        <div className="error-box" data-testid="error-box">
            <div className="error-box__message-wrapper">
                <h1 className="error-box__title">Oops...</h1>
                <p>{message}</p>
            </div>
        </div>
    );
};
